import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { Add } from "@mui/icons-material";
import moment from "moment";
import ScheduleEntryRow from "./ScheduleEntryRow";

function ScheduleEntryList({ entries, setEntries, isEditMode }) {
  const hasImmediateEntry = entries.some(
    (e) => e.notification_send_type === "1" || e.notification_send_type === 1
  );

  const isEntrySent = (e) => String(e?.notification_send_status) === "1";

  const handleUpdate = (index, updatedEntry) => {
    if (isEntrySent(entries[index])) return; // sent rows immutable
    const newEntries = [...entries];
    newEntries[index] = updatedEntry;
    setEntries(newEntries);
  };

  const handleRemove = (index) => {
    if (entries.length <= 1 || isEntrySent(entries[index])) return;
    setEntries(entries.filter((_, i) => i !== index));
  };

  const handleAdd = () => {
    setEntries([
      ...entries,
      {
        s_date: moment().format("DD-MM-YYYY"),
        e_date: "",
        notification_send_type: "0",
        n_date_time: "",
        show_on_home: 0,
        _uid: `entry_${Date.now()}_${Math.random()
          .toString(36)
          .substr(2, 9)}`
      }
    ]);
  };

  return (
    <Box>
      <Typography variant="subtitle1" fontWeight={600} gutterBottom>
        Schedule Dates
      </Typography>
      {entries.map((entry, index) => (
        <ScheduleEntryRow
          key={entry._uid || entry.n_id || index}
          entry={entry}
          index={index}
          totalEntries={entries.length}
          hasImmediateEntry={hasImmediateEntry}
          onUpdate={handleUpdate}
          onRemove={handleRemove}
          isEditMode={isEditMode}
        />
      ))}
      <Button
        startIcon={<Add />}
        variant="outlined"
        onClick={handleAdd}
        sx={{ mt: 1, textTransform: "none" }}
      >
        Add Schedule Date
      </Button>
    </Box>
  );
}
export default ScheduleEntryList;
